module.exports = __webpack_public_path__ + "static/media/home-krane.688387ae.jpeg";